const NOTIFICATION_BACKGROUND_COLOR = '#f2547d';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getNotificationBackgroundColor = theme => NOTIFICATION_BACKGROUND_COLOR;